import { useState } from "react";
import { api } from "../../../../../../../utility/api";

export const AlmacenesInventarioApi = () => {
    const [cargando, setCargando] = useState(false);

    const getAlmacenesInventario = async (idInventario) => {
        try {
            setCargando(true);
            const response = await api.get(
                `almacen_inventario/${idInventario}/almacenes`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarInventario = async (idInventario, datos) => {
        try {
            setCargando(true);
            const response = await api.patch(
                `historico_inventarios/${idInventario}`,
                datos,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const guardarReajusteInventario = async (inventarioAlmacenId, datos) => {
        try {
            setCargando(true);

            const response = await api.post(
                `almacen_inventario/ajustar_inv_inicial/${inventarioAlmacenId}`,
                datos,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const eliminarReajusteInventario = async (inventarioAlmacenId) => {
        try {
            setCargando(true);

            const response = await api.post(
                `almacen_inventario/eliminar_reajuste/${inventarioAlmacenId}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarEstadoAlmacen = async (inventarioAlmacenId, datos) => {
        try {
            setCargando(true);

            const response = await api.post(
                `almacen_inventario/actualizar_estado_almacen/${inventarioAlmacenId}`,
                datos,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getPadresProductoTerminado = async (params) => {
        return api
            .get("padres_producto_terminado", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    return {
        getAlmacenesInventario,
        actualizarInventario,
        guardarReajusteInventario,
        eliminarReajusteInventario,
        actualizarEstadoAlmacen,
        getPadresProductoTerminado,

        cargando,
    };
};
